<template>
    <div>
        <!-- 日期选择器 -->
        <Row :gutter="10" style="margin-top: 10px;" class="time-slot">
            <!-- 开始时间 -->
            <Col :xs="10" :sm="10" :md="8" :lg="4" :xl="6">
            开始时间：
            <DatePicker
                v-model="startDate"
                size="large"
                type="date"
                format="yyyy-MM-dd"
                :editable="false"
                placeholder="请选择开始时间"
                @on-change="changeDate($event,1)"
                ref="startDateRef"
            ></DatePicker>
            </Col>
            <!-- 结束时间 -->
            <Col :xs="10" :sm="10" :md="8" :lg="4" :xl="6">
            结束时间：
            <DatePicker
                v-model="endDate"
                size="large"
                type="date"
                :editable="false"
                format="yyyy-MM-dd"
                placeholder="请选择结束时间"
                @on-change="changeDate($event,2)"
                ref="endDateRef"
            ></DatePicker>
            </Col>
            <!-- 查询时间按钮 -->
            <Col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <Button type="primary" @click.native="search">查询</Button>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                startDate: "", //选择的开始时间
                endDate: "", //选择的结束时间
                startDateStr: "", //默认开始时间
                endDateStr: "", //默认结束时间
                startDateIsChange: false, //开始日期是否改变
                endDateIsChange: false //结束日期是否改变
            };
        },
        methods: {
            /**
             * 修改时间选择后dom赋值
             */
            changeDate (el, type) {
                //开始日期
                if (type == 1) {
                    this.startDate = el;
                    this.startDateIsChange = true;
                } else {
                    //结束日期
                    this.endDate = el;
                    this.endDateIsChange = true;
                }
            },
            /**
             * 查询按钮点击事件
             */
            search () {
                let curStartDate = this.startDateStr;
                let curEndDate = this.endDateStr;
                if (this.startDateIsChange) {
                    curStartDate = this.startDate;
                }
                if (this.endDateIsChange) {
                    curEndDate = this.endDate;
                }
                this.$emit("updateDateTime", curStartDate, curEndDate);
            },
            /**
             * 设置默认日期
             */
            setDate (startDate, endDate) {
                this.startDate = startDate;
                this.endDate = endDate;
                //用于未选择时间直接点查询按钮的情况
                this.startDateStr = startDate;
                this.endDateStr = endDate;
            }
        },
    };
</script>


<style lang="scss" scoped>

</style>

<style lang="scss">
    .time-slot {
        @media (min-width : 1200px) {
            .ivu-col-span-lg-4 {
                display : block;
                width   : 20%;
            }
            /*.ivu-col-span-xl-6 {*/
                /*display: block;*/
                /*width: 25%;*/
            /*}*/
        }
    }
</style>
